import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";
import {
  IFilingResponse,
  IFormITR1,
  ITRFilingParams,
  IUserParams,
  IUserResponse
} from "../config/interfaces";
import InitApi from "./init";

class ITRFilingApi {
  static _instance: ITRFilingApi;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new ITRFilingApi();
    return this._instance;
  };

  _apiSvc;

  constructor() {
    this._apiSvc = InitApi.getInstance();
  }

  getITRFilings = async (
    params: ITRFilingParams
  ): Promise<{ count: number; records: IFilingResponse[] }> => {
    const { search, offset = 0, count = 10, orderBy, order, userUuid, authorized } = params;
    let url = `efiling?offset=${offset}`;

    if (search) {
      url += `&search=${search}`;
    }
    if (count) {
      url += `&count=${count}`;
    }
    if (orderBy) {
      url += `&orderBy=${orderBy}`;
    }
    if (order) {
      url += `&order=${order}`;
    }
    if (userUuid) {
      url += `&userUuid=${userUuid}`;
    }
    if (authorized !== undefined) {
      url += `&authorized=${authorized}`;
    }

    const response = await this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
    return response.data;
  };

  createITRFiling = async (data: {
    efilingData: IFormITR1;
    name: string;
    pan: string;
    assessmentYear: string;
  }): Promise<IFilingResponse> => {
    const response = await this._apiSvc.post(`${appConstants.apiUrl}/efiling`, data);
    return response.data;
  };

  updateITRFiling = async (
    uuid: string,
    data: { efilingData: IFormITR1; name: string; pan: string; assessmentYear: string }
  ): Promise<IFilingResponse> => {
    const response = await this._apiSvc.put(`${appConstants.apiUrl}/efiling/single/${uuid}`, data);
    return response.data;
  };

  getFilingByUuId = async (uuid: string): Promise<IFilingResponse> => {
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/efiling/single/${uuid}`);
    return response.data;
  };

  deleteFilingByUuIds = async (uuids: string[]): Promise<AxiosResponse> => {
    return this._apiSvc.delete(`${appConstants.apiUrl}/efiling`, { data: uuids });
  };

  getTaxExperts = async (
    params: IUserParams
  ): Promise<{ count: number; records: IUserResponse[] }> => {
    const { search, offset = 0, count = 10, orderBy, order, role, inactive } = params;
    let url = `user?offset=${offset}`;

    if (search) {
      url += `&search=${search}`;
    }
    if (count) {
      url += `&count=${count}`;
    }
    if (orderBy) {
      url += `&orderBy=${orderBy}`;
    }
    if (order) {
      url += `&order=${order}`;
    }
    if (role) {
      url += `&role=${role}`;
    }
    if (inactive !== undefined) {
      url += `&inactive=${inactive}`;
    }
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
    return response.data;
  };

  getAssignExpert = async (offset: number, count: number): Promise<AxiosResponse> => {
    let url = `efiling-authorized-user?`;
    if (offset >= 0) {
      url += `&offset=${offset}`;
    }
    if (count) {
      url += `&count=${count}`;
    }
    return this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
  };

  assignExpert = async (data: {
    efilingUuid: string;
    userUuid: string;
  }): Promise<AxiosResponse> => {
    const response = await this._apiSvc.post(
      `${appConstants.apiUrl}/efiling-authorized-user`,
      data
    );
    return response.data;
  };

  deleteAssignFilingByUuIds = async (uuids: string[]): Promise<AxiosResponse> => {
    return this._apiSvc.delete(`${appConstants.apiUrl}/efiling-authorized-user`, {
      data: { uuids: uuids }
    });
  };

  // set filing status
  setEfilingStatus = async (
    data: {
      status: String;
    },
    uuid: string | undefined
  ): Promise<AxiosResponse> => {
    const response = await this._apiSvc.put(`${appConstants.apiUrl}/efiling/status/${uuid}`, data);
    return response.data;
  };
}

export default ITRFilingApi;
